"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WatchingIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

var _excluded = ["title"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/** WatchingIcon */


var WatchingIcon = function WatchingIcon(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Watching" : _ref$title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 10 12"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Title, null, title), /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    d: "M1.337 11.896c.28 0 .424-.156.983-.682l2.417-2.32c.123-.113.188-.145.263-.145.075 0 .15.037.263.145l2.745 2.642c.215.204.381.36.655.36.338 0 .596-.204.596-.693V2.045c0-1.117-.553-1.68-1.665-1.68H2.406C1.299.364.74.927.74 2.044v9.158c0 .489.263.693.596.693z",
    fill: (0, _helpers.color)(props.fill),
    fillRule: "nonzero"
  }));
};

exports.WatchingIcon = WatchingIcon;
WatchingIcon.displayName = "WatchingIcon";